export default __webpack_public_path__ + "static/media/MiniTape_SideA_05_Telefonbenatworter-Ernst-Hostettler.7927a789.mp3";